"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo, useRef, useState } from "react";
import { cn } from "../../../utils/index.js";
import { cleanTableProps } from "../cleanTableProps.js";
import { LoadingSpinner } from "../LoadingSpinner.js";
import { TableContext } from "./Table.context.js";
import { tableVariants } from "./Table.variants.js";
function Table({ children, className, ...props }) {
    const [placeholder, setPlaceholder] = useState(false);
    const [maxColumns, setMaxColumns] = useState(0);
    const { scrollable, scrollClassName = 'h-50 w-4xl', bordered, headerSticky, headerCellInteractive, firstColumnSticky, striped, cellLineClamp, cellMaxWidth, cellSize, cellTextWrap, cellWordBreak, color, isGroupHeader, loading } = props;
    const styles = tableVariants(props);
    const cleanedProps = cleanTableProps(props);
    const containerClassName = cn(styles.container(), scrollable ? scrollClassName : '');
    const tableRef = useRef(null);
    const contextValue = useMemo(()=>({
            bordered,
            scrollable,
            scrollClassName,
            headerSticky,
            headerCellInteractive,
            firstColumnSticky,
            striped,
            cellLineClamp,
            cellMaxWidth,
            cellSize,
            cellTextWrap,
            cellWordBreak,
            color,
            isGroupHeader,
            loading,
            placeholder,
            setPlaceholder,
            maxColumns,
            setMaxColumns
        }), [
        bordered,
        scrollable,
        scrollClassName,
        headerSticky,
        headerCellInteractive,
        firstColumnSticky,
        striped,
        cellLineClamp,
        cellMaxWidth,
        cellSize,
        cellTextWrap,
        cellWordBreak,
        color,
        isGroupHeader,
        loading,
        placeholder,
        maxColumns
    ]);
    const tableSize = useMemo(()=>{
        const tableSizes = {};
        if (tableRef.current) {
            const tableElement = tableRef.current;
            const tHeadElement = tableElement.tHead;
            const container = tableElement.parentElement;
            tableSizes['--table-width'] = (props.scrollable ? container?.offsetWidth : tableElement?.offsetWidth) ?? 0;
            tableSizes['--table-height'] = (props.scrollable ? container?.offsetHeight : tableElement?.offsetHeight) ?? 0;
            tableSizes['--table-head-height'] = tHeadElement?.offsetHeight ?? 0;
        }
        return tableSizes;
    }, [
        tableRef?.current?.offsetHeight,
        tableRef?.current?.tHead?.offsetHeight,
        tableRef?.current?.offsetWidth,
        props.headerSticky,
        props.scrollable
    ]);
    return /*#__PURE__*/ jsx(TableContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ jsxs("div", {
            className: "relative isolate",
            style: {
                ...tableSize
            },
            children: [
                /*#__PURE__*/ jsx("div", {
                    className: containerClassName,
                    ...cleanedProps,
                    children: /*#__PURE__*/ jsx("table", {
                        className: cn(styles.base(), className),
                        ref: tableRef,
                        children: children
                    })
                }),
                /*#__PURE__*/ jsx(LoadingSpinner, {
                    loading: props.loading,
                    scrollable: scrollable,
                    colSpan: maxColumns,
                    headerSticky: props.headerSticky
                })
            ]
        })
    });
}
export { Table };
